import React from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import almacuraImage from '../images/AlmacuraImage.png';
import mlcImage from '../images/MlcImage.png';
import tgmImage from '../images/TgmImage.png';
import otpImage from '../images/OTPImage.jpg';
const ProjectsContainer = styled.div`
  padding: 0;
  max-width: 1200px;
  margin: 0 auto;
  background-color: ${props => props.theme.colors.background};
`;

const HeroSection = styled.div`
  background: linear-gradient(135deg, 
    ${props => props.theme.colors.primary}, 
    ${props => props.theme.colors.secondary}
  );
  padding: ${props => props.theme.spacing.xxl} 0;
  color: white;
  text-align: center;
  min-height: 30vh; /* Adjust height as needed */
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ProjectsHeader = styled(motion.h1)`
  color: white; /* Change to white for visibility on gradient */
  font-size: 3rem;
`;

const ProjectsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: ${props => props.theme.spacing.xl};
  padding: ${props => props.theme.spacing.xxl};
`;

const ProjectCard = styled(motion.div)`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0px 10px 30px rgba(0,0,0,0.2);
  }
`;

const ProjectImage = styled.div`
  height: 200px;
  background: ${props => `url(${props.image}) no-repeat center center`};
  background-size: cover;
`;

const ProjectInfo = styled.div`
  padding: ${props => props.theme.spacing.lg};
`;

const ProjectTitle = styled.h3`
  margin: 0;
  color: ${props => props.theme.colors.secondary};
`;

const ProjectDescription = styled.p`
  color: ${props => props.theme.colors.text};
`;

const ProjectTags = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const Tag = styled.span`
  background-color: ${props => props.theme.colors.primaryLight};
  color: ${props => props.theme.colors.primary};
  padding: .25rem .5rem;
  border-radius: .25rem;
`;

const projects = [
  {
    id: 1,
    title: "International Skincare Company",
    description: "Led development of multilingual, WCAG-compliant features for an international skincare company. Integrated Shopify Plus with custom React components, optimized site performance for global traffic, and implemented analytics tracking to support data-driven marketing strategies.",
    color: "#666666",
    tags: ["Shopify Plus", "React", "SQL"],
    image: otpImage
},
    {
        id: 2,
        title: "Mental Health Platform for US Latinos",
        description: "A digital platform offering affordable, culturally relevant therapy services tailored to the mental health needs of US-based Latinos.",
        color: "#666666",
        tags: ["TypeScript", "Javascript", "APIs"],
        image: almacuraImage
    },
    {
      id: 3,
      title: "Shopify Site for Women-Led Marketplace",
      description: "A Shopify-based platform serving as a hub for women-owned businesses to apply for spots in the marketplace and learn more about the nonprofit's mission and events.",
      color: "#666666",
      tags: ["Shopify", "CSS", "E-commerce"],
      image: tgmImage
    },
    {
      id: 4,
      title: "WordPress Website for Mariachi Group",
      description: "A visually engaging WordPress site with custom HTML and CSS to promote performances, share multimedia content, and streamline the booking process for a traditional mariachi group.",
      color: "#666666",
      tags: ["WordPress", "HTML", "CSS"],
      image: mlcImage
  },
    // Add more projects...
];

function ProjectsPage() {
    return (
        <ProjectsContainer>
            <HeroSection>
                <ProjectsHeader
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                >
                    Featured Projects
                </ProjectsHeader>
            </HeroSection>
            <ProjectsGrid>
                {projects.map((project, index) => (
                    <Link 
                        to={`/project/${project.id}`} 
                        key={project.id}
                        style={{ textDecoration: 'none' }}
                    >
                        <ProjectCard
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: -10 }}
                            transition={{ duration: index * .1 + .5 }}
                        >
                            <ProjectImage image={project.image} />
                            <ProjectInfo>
                                <ProjectTitle>{project.title}</ProjectTitle>
                                <ProjectDescription>{project.description}</ProjectDescription>
                                <ProjectTags>
                                    {project.tags.map((tag, tagIndex) => (
                                        <Tag key={tagIndex}>{tag}</Tag>
                                    ))}
                                </ProjectTags>
                            </ProjectInfo>
                        </ProjectCard>
                    </Link>
                ))}
            </ProjectsGrid>
        </ProjectsContainer>
    );
}

export default ProjectsPage;
